/* eslint-disable */
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  ActivatedRoute,
  NavigationExtras,
  Params,
  Router,
} from "@angular/router";
import { CommonModule, DatePipe } from "@angular/common";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { Calendar } from "primeng/calendar";
import { AddContactInformationComponent } from "../add-contact-information/add-contact-information.component";
import buildQuery from "odata-query";
import { AddAddressInformationComponent } from "../add-address-information/add-address-information.component";
import { ViewContactInformationComponent } from "../view-contact-information/view-contact-information.component";
import { ViewAddressInformationComponent } from "../view-address-information/view-address-information.component";
import { ClientDto } from "../../../../core/models/client/details/clientDto";
import { Client } from "../../../../core/models/client/details/client";
import { ClientContact } from "../../../../core/models/client/details/clientContact";
import { CustomerCommission } from "../../../../core/models/client/details/customerCommission";
import { ClientAddressCustomize } from "../../../../core/models/client/details/clientAddresscustomize";
import { CustomerGroup } from "../../../../core/models/client/addclient/customerGroupList";
import { Currency } from "../../../../core/models/client/addclient/currencyList";
import { Source } from "../../../../core/models/client/addclient/sourceList";
import { OpenInvoiceAmountTilesDto } from "../../../../core/models/client/details/openInvoiceAmountTilesDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { ClientPurposeType } from "../../../../shared/enums/clientpurposetype";
import { FileName } from "../../../../shared/enums/fileName";
import { EnumContactType } from "../../../../shared/enums/enumContactType";
import { ClientContactType } from "../../../../shared/enums/clientContactType";
import {
  SharedService,
  getBase64,
} from "../../../../core/services/shared.service";
import { InputTextModule } from "primeng/inputtext";
import { AttachmentComponent } from "../../../../shared/components/attachment/attachment.component";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { DatePickerModule } from "primeng/datepicker";
import { ScrollerModule } from "primeng/scroller";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { ClientInvoiceAmountsComponent } from "../client-invoice-amounts/client-invoice-amounts.component";
import { PanelModule } from "primeng/panel";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CalendarModule } from "primeng/calendar";
import { UpdateCustomerPODto } from "../../../../core/models/client/details/updateCustomerPODto";
import { SelectModule } from "primeng/select";
import { Employee } from "../../../../core/models/profile/employee";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { ClientDetailsService } from "../../../../core/services/client-details.service";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { AddNewClientService } from "../../../../core/services/add-new-client.service";
import { UsersList } from "../../../../core/models/users/users/usersList";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { CustomerTransactions } from "../../../../core/models/client/details/customerTransaction";
import { ClientContract } from "../../../../core/models/client/details/clientContract";
import { Address } from "../../../../core/models/shared/address";
import { FileUploadDto } from "../../../../core/models/shared/fileUploadDto";
import { ClientAttachment } from "../../../../core/models/client/details/clientAttachment";
import { ProductionWorkflowListingComponent } from "../../../project-workflow/production-workflow-listing/production-workflow-listing.component";
import { CardModule } from "primeng/card";

@UntilDestroy()
@Component({
  selector: "jni-client-details",
  templateUrl: "./client-details.component.html",
  styleUrls: ["./client-details.component.scss"],
  imports: [
    AddContactInformationComponent,
    AddAddressInformationComponent,
    ViewContactInformationComponent,
    ViewAddressInformationComponent,
    CommonModule,
    DatePipe,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    AttachmentComponent,
    HidedynamicsdatePipe,
    DatePickerModule,
    ScrollerModule,
    ClientInvoiceAmountsComponent,
    ModalStackerComponent,
    PanelModule,
    AutoCompleteModule,
    CalendarModule,
    SelectModule,
    ScrollPanelModule,
    ToggleSwitchModule,
    ProductionWorkflowListingComponent,
    CardModule,
  ],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class ClientDetailsComponent implements OnInit, OnChanges, OnDestroy {
  public isCollapsed = false;
  public isCollapseOne = false;
  public isCollapseTwo = false;
  public isCollapseThree = false;
  public isCollapseFour = false;
  public isCollapseFive = false;
  public isCollapseSix = false;
  public isCollapseSeven = false;
  @Input() isModal = false;
  isCollapseAll = true;

  collapseStatus = false;
  expandStatus = true;
  collapseHeading = "Collapse all";

  clientInformation?: ClientDto;
  clientBasicInformation?: Client = {} as Client;
  clientContactInformation?: ClientContact[] = [];
  clientAddressInformation?: Address[] = [];
  clientContractInformation?: ClientContract[] = [];
  clientAttachmentInformation?: ClientAttachment[] = [];
  clientTranscationInformation?: CustomerTransactions;
  clientCommissionInformation?: CustomerCommission[] = [];
  clientEmployeeInformation?: Employee = {} as Employee;
  // clientCreditCardInformation?: any;
  // clientCommissionSetupInformation?: any;
  // clientMiscellaneousInformation?: any;
  date: Date = new Date();
  clientId = "";
  resaleAttachmenturl: string | undefined = "";
  descriptionD365: string | undefined = "";
  taxAttachmenturl: string | undefined = "";
  taxdescriptionD365: string | undefined = "";
  fileAttachment: ClientAttachment[] = [];
  contactoneFileName = "";
  contactoneFileSize = false;
  fileObject: FileUploadDto[] = [];
  fileUrl = "";
  clientContractFileIdOne = "file1";
  clientContractFileIdTwo = "file2";
  clientContractDateIdFrom = "Effect From";
  clientContractDateIdTo = "Effect to";
  ClientAddresses: ClientAddressCustomize[] = [];
  showSmallLoader = false;
  customerGroupList: CustomerGroup[] = [];
  isResaleToggleStatus = false;
  parentCompanyNameList: Client[] = [];
  bacUserDefaultSelectionId = "";
  customerGroupId = "";
  sourceId = "";
  bcList: UsersList[] = [];
  bacList: UsersList[] = [];
  currencyList: Currency[] = [];
  sourceList: Source[] = [];
  clientSummaryForm: FormGroup;
  miscellaneousDataForm: FormGroup;
  parentCompanyName: { id: number; nameAliasD365: string } = {
    id: 0,
    nameAliasD365: "",
  };
  taxexemption = "taxexemption";
  resale = "resale";
  documentType = "";
  dimensionDepartmentCodeD365 = "";
  dimensionDepartmentValueD365 = "";
  dimensionLocationsCodeD365 = "";
  dimensionLocationValueD365 = "";
  dimensionProgramCodeD365 = "";
  dimensionProgramValueD365 = "";
  clientType = "";
  displayAddContact = false;
  displayViewContact = false;
  clientObject!: ClientAddressCustomize;
  contactHeadingStatus = true;
  addressHeadingStatus = true;
  displayViewAddress = false;
  displayCreateAddress = false;
  addressObject = {} as Address;
  customerBalance = 0;
  openReceivables = 0;
  openOrders = 0;
  FYTDSales = 0;
  lastOrderDate = "";
  invoiceDate = "";
  openInvoiceAmountTilesData = {
    openAmount120: 0,
    openAmount60: 0,
    openAmount90: 0,
  } as OpenInvoiceAmountTilesDto;
  effectFrom = "";
  PoCheck = false;
  effectTo = "";
  clientModalStatus = false;
  openInvoiceDisplayModal = false;
  openInvoiceCustomerAccount = "";
  openInvoicetype = 0;
  partyNumber = "";
  dimensionProgramSubCategoryCode = "";
  dimensionProgramSubCategoryValue = "";
  openClientArchiveModal = false;
  // parentCompanySuggestions: any[] = [];

  @Input() clientIdFromModal = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeModalOnRedirectionEvent = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  @ViewChild("contactForm", { static: false })
  contactForm!: AddContactInformationComponent;
  @ViewChild("refEffectiveTo") refEffectiveTo!: Calendar;
  @ViewChild("refEffectiveFrom") refEffectiveFrom!: Calendar;
  constructor(
    private _clientDetailsService: ClientDetailsService,
    private router: ActivatedRoute,
    public datepipe: DatePipe,
    public _loaderService: LoaderService,
    private _addNewClientService: AddNewClientService,
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private renderer: Renderer2,
    private _router: Router,
    private _sharedService: SharedService
  ) {
    this.router.params.subscribe((params: Params) => {
      if (!this.clientId) {
        this.clientId = params["id"];
      }
    });
    this.clientSummaryForm = this._formBuilder.group({
      dUNSNoD365: [""],
      brandingAccountCordinator: [""],
      knownAsD365: [""],
      customerGroupIdD365: [""],
      rsmJNIParentCompanyNameD365: [""],
      source: [""],
      salesCurrencyCodeD365: [""],
      companyUrl: [""],
      isRequestCreditCheck: [""],
      requestCreditIncreaseAmount: [0],
      isRequestCreditIncrease: [""],
      billingLocationD365: [""],
      billingAttentionD365: [""],
    });
    this.miscellaneousDataForm = this._formBuilder.group({
      shippingMethodD365: [""],
      rsmJNIClientFreightAcctD365: [""],
      priority: [""],
    });
  }

  element!: HTMLElement;
  ngAfterViewInit() {
    const element = document?.getElementById("resale");
    if (element) {
      this.element = element;
      this.element.style.display = "none";
    }
    const taxExemptionElement = document?.getElementById("taxexemption");
    if (taxExemptionElement) {
      this.element = taxExemptionElement;
      this.element.style.display = "none";
    }
  }

  ngOnChanges() {
    if (this.clientIdFromModal) {
      this.clientId = this.clientIdFromModal;
      this.clientModalStatus = true;
      //this.ngOnInit();
    }
  }

  ngOnInit(): void {
    if (this.clientId) {
      this.syncDeletedCommissions();
      this.getClientInformationData();
      this.getCustomerGroupListData();
      this.getCurrencyListData();
      this.getSourceListData();
      this.getParentCompanyNameListData();
      this.openInvoiceAmountTiles();
      this.getAvailableCredit();
      this.getOpenOrder();
      this.getFYTDSales();
    }

    this.miscellaneousDataForm.get("priority")?.disable();
  }

  syncDeletedCommissions() {
    const odataFilter = `?$filter=ID eq '${this.clientId}'`;
    this._clientDetailsService
      .GetJNIDeletedRecordsFilter(odataFilter)
      .subscribe();
  }

  syncDeletedAddress() {
    const odataFilter = `?$filter=ID eq '${this.partyNumber}'`;
    this._clientDetailsService
      .GetJNIDeletedRecordsFilter(odataFilter)
      .subscribe();
  }

  syncDeletedContacts(contacts: ClientContact[]) {
    const filterList = [];
    for (const contact of contacts) {
      if (contact.electronicAddressIdD365) {
        filterList.push({ ID: contact.electronicAddressIdD365 });
      }
    }

    const filter = {
      or: filterList,
    };
    const query = buildQuery({ filter });
    this._clientDetailsService.GetJNIDeletedRecordsFilter(query).subscribe();
  }

  onEditContact(clientObject: ClientAddressCustomize) {
    this.clientObject = clientObject;
    this.contactHeadingStatus = false;
    // this.contactForm.patchValueInClientForm(clientObject);
    this.displayAddContact = true;
  }

  onEditAddress(addressObject: Address) {
    this.addressObject = addressObject;
    this.addressHeadingStatus = false;
    // this.contactForm.patchValueInClientForm(clientObject);
    this.displayCreateAddress = true;
  }

  onOpenEditContact(event: ClientAddressCustomize) {
    this.onEditContact(event);
  }

  onOpenEditAddress(event: Address) {
    this.onEditAddress(event);
  }

  addContactInformation() {
    this.displayAddContact = true;
    this.contactHeadingStatus = true;
  }

  onCreateAddress() {
    this.displayCreateAddress = true;
    this.addressHeadingStatus = true;
  }

  viewContactInformation() {
    this.displayViewContact = true;
  }

  onAddressView() {
    this.displayViewAddress = true;
  }

  getParentCompanyNameListData() {
    this._addNewClientService
      .getParentCompanyNameList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.parentCompanyNameList = res.data;
        },
      });
  }

  openInvoiceAmountTiles() {
    if (this.clientId) {
      this._clientDetailsService
        .openInvoiceAmountTiles(this.clientId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.openInvoiceAmountTilesData = {
                openAmount120: res.data.openAmount120 ?? 0,
                openAmount60: res.data.openAmount60 ?? 0,
                openAmount90: res.data.openAmount90 ?? 0,
              };
            } else {
              this.openInvoiceAmountTilesData = {
                openAmount120: 0,
                openAmount60: 0,
                openAmount90: 0,
              };
            }
          },
        });
    }
  }

  orderHistoryRedirect() {
    const state = {
      state: {
        customerAccountNumber: this.clientId,
      },
    } as NavigationExtras;

    this._router.navigate(["/orders"], state);
  }

  getCustomerGroupListData() {
    this._addNewClientService
      .getCustomerGroupList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.customerGroupList = res?.data;
        },
      });
  }

  getCurrencyListData() {
    this._addNewClientService
      .getCurrencyList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.currencyList = res.data;
        },
      });
  }

  getSourceListData() {
    this._addNewClientService
      .getSourceList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.sourceList = res?.data;
        },
      });
  }

  patchValueInBasicAndCreditCard(client?: ClientDto) {
    if (client) {
      this.clientSummaryForm.patchValue({
        dUNSNoD365: client.client?.dunsNoD365,
        brandingAccountCordinator: client.client?.brandingAccountCordinator,
        knownAsD365: client.client?.knownAsD365,
        customerGroupIdD365: client.client?.customerGroupIdD365,
        rsmJNIParentCompanyNameD365: client.client?.rsmJNIParentCompanyNameD365,
        source: client.client?.source,
        salesCurrencyCodeD365: client.client?.salesCurrencyCodeD365,
        companyUrl: client.client?.companyUrl,
        isRequestCreditCheck: client.client?.isRequestCreditCheck,
        requestCreditIncreaseAmount: client.client?.requestCreditIncreaseAmount,
        isRequestCreditIncrease: client.client?.isRequestCreditIncrease,
        billingAttentionD365: client.client?.billingAttentionD365,
        billingLocationD365: client.client?.billingLocationD365,
      });
      this.miscellaneousDataForm.patchValue({
        shippingMethodD365: client.client?.shippingMethodD365,
        rsmJNIClientFreightAcctD365: client.client?.rsmJNIClientFreightAcctD365,
        priority: client.client?.priorityD365,
      });
      if (client.client?.rsmJNIParentCompanyNameD365) {
        this.parentCompanyName = {
          id: 0,
          nameAliasD365: client.client?.rsmJNIParentCompanyNameD365,
        };
      }
    }
  }

  disabledDunsNo(lastCheckDate: string) {
    if (lastCheckDate) {
      this.clientSummaryForm.get("dUNSNoD365")?.disable();
    } else {
      this.clientSummaryForm.get("dUNSNoD365")?.enable();
    }
  }

  patchValueInFinancialDimension(clientBasicInformation: Client) {
    this.dimensionDepartmentCodeD365 =
      clientBasicInformation?.dimensionDepartmentCodeD365 ?? "";
    this.dimensionDepartmentValueD365 =
      clientBasicInformation?.dimensionDepartmentValueD365 ?? "";
    this.dimensionLocationsCodeD365 =
      clientBasicInformation?.dimensionLocationsCodeD365 ?? "";
    this.dimensionLocationValueD365 =
      clientBasicInformation?.dimensionLocationsValueD365 ?? "";
    this.dimensionProgramValueD365 =
      clientBasicInformation?.dimensionProgramValueD365 ?? "";
    this.dimensionProgramCodeD365 =
      clientBasicInformation?.dimensionProgramCodeD365 ?? "";
    this.dimensionProgramSubCategoryCode =
      clientBasicInformation?.dimensionProgramSubCategoryCode ?? "";
    this.dimensionProgramSubCategoryValue =
      clientBasicInformation?.dimensionProgramSubCategoryValue ?? "";
  }

  getClientInformationData() {
    this._loaderService.setLoaderState(true);
    this.showSmallLoader = true;
    this._clientDetailsService
      .getClientInformation(this.clientId?.toString() ?? "")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.showSmallLoader = false;
          this.clientInformation = res.data;
          this.clientBasicInformation = this.clientInformation?.client;
          this.clientContactInformation =
            this.clientInformation?.clientContacts;
          if (this.clientInformation?.clientAddress) {
            this.clientAddressInformation =
              this.clientInformation?.clientAddress ?? undefined;
          }
          this.clientContractInformation =
            this.clientInformation?.clientContract ?? [];
          this.clientContractInformation.forEach((contract: ClientContract) => {
            if (contract.effectiveFrom) {
              contract.effectiveFrom = this.parseToDate(contract.effectiveFrom);
            }
            if (contract.effectiveTo) {
              contract.effectiveTo = this.parseToDate(contract.effectiveTo);
            }
          });
          this.clientAttachmentInformation =
            this.clientInformation?.clientAttachment;
          this.clientTranscationInformation =
            this.clientInformation?.customerTransactions;
          this.clientCommissionInformation =
            this.clientInformation?.customerCommissions;
          this.clientEmployeeInformation = this.clientInformation?.employee;

          if (this.clientBasicInformation) {
            this.partyNumber = this.clientBasicInformation.partyNumberD365;
            this.syncDeletedAddress();
          }

          if (this.clientContactInformation) {
            this.syncDeletedContacts(this.clientContactInformation);
          }

          if (this.clientBasicInformation != undefined) {
            this.bacUserDefaultSelectionId =
              this.clientBasicInformation?.brandingAccountCordinator;
          }
          if (this.clientBasicInformation != undefined) {
            this.customerGroupId =
              this.clientBasicInformation?.customerGroupIdD365;
          }
          if (this.clientBasicInformation != undefined) {
            this.sourceId = this.clientBasicInformation?.source;
          }

          this.clientType =
            this.clientInformation?.client?.clientType?.toLowerCase() ?? "";

          this.patchValueInBasicAndCreditCard(this.clientInformation);
          if (this.clientInformation?.client != undefined) {
            this.getBCListData(
              this.clientInformation?.client?.bCPersonnelNumberD365 ?? ""
            );
          }
          if (this.clientInformation?.client != undefined) {
            if (
              this.clientInformation?.client?.lastCreditCheckDateD365 !=
              "1900-01-01T12:00:00"
            ) {
              this.disabledDunsNo(
                this.clientInformation?.client?.lastCreditCheckDateD365 ?? ""
              );
            }
          }
          if (this.clientInformation?.client?.customerPoEffectiveFrom) {
            const date = new Date(
              this.clientInformation?.client?.customerPoEffectiveFrom
            );
            const effectFromdate = this.datepipe.transform(date, "MM/dd/yyyy");
            // const effectFromdate = new Date(
            //   this.clientInformation.client?.customerPoEffectiveFrom
            // ).toLocaleDateString();
            this.patchValueInCustomerPOEffectFrom(effectFromdate ?? "");
          }
          if (this.clientInformation?.client?.customerPoEffectiveTo) {
            const date = new Date(
              this.clientInformation?.client?.customerPoEffectiveTo
            );
            const effectTodate = this.datepipe.transform(date, "MM/dd/yyyy");
            // const effectTodate = new Date(
            //   this.clientInformation.client?.customerPoEffectiveTo
            // ).toLocaleDateString();
            this.patchValueInCustomerPOEffectTo(effectTodate ?? "");
          }
          if (this.clientInformation?.client?.customerPORequired) {
            this.patchValueInCustomerPORequired(
              this.clientInformation?.client?.customerPORequired
            );
          }
          if (this.clientBasicInformation) {
            this.patchValueInFinancialDimension(this.clientBasicInformation);
          }
          this.transformClientContactData();
          if (
            this.clientAttachmentInformation?.find(
              x => x.descriptionD365 == FileName.resale
            ) != undefined
          ) {
            this.resaleAttachmenturl = this.clientAttachmentInformation?.find(
              x => x.descriptionD365 == FileName.resale
            )?.notesD365;
            this.descriptionD365 = this.clientAttachmentInformation?.find(
              x => x.descriptionD365 == FileName.resale
            )?.descriptionD365;
          }
          if (
            this.clientAttachmentInformation?.find(
              x => x.descriptionD365 == FileName.taxExemption
            ) !== undefined
          ) {
            this.taxAttachmenturl = this.clientAttachmentInformation?.find(
              x => x.descriptionD365 == FileName.taxExemption
            )?.notesD365;
            this.taxdescriptionD365 = this.clientAttachmentInformation?.find(
              x => x.descriptionD365 == FileName.taxExemption
            )?.descriptionD365;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this.showSmallLoader = false;
        },
      });
  }

  patchValueInCustomerPORequired(customerPORequired: boolean) {
    this.PoCheck = customerPORequired;
  }

  patchValueInCustomerPOEffectFrom(effectFromDate: string) {
    if (effectFromDate) {
      this.effectFrom = effectFromDate;
    }
  }

  patchValueInCustomerPOEffectTo(effectFromTo: string) {
    if (effectFromTo) {
      this.effectTo = effectFromTo;
    }
  }

  getBCListData(bcName: string) {
    this._addNewClientService
      .getBCList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.bcList = res.data;
          if (this.bcList.length > 0) {
            const object = this.bcList.filter(x => x.personnelNumber == bcName);
            if (object.length > 0) {
              this.getBACList(object[0].id);
            }
          }
        },
      });
  }

  getBACList(id: number) {
    this._addNewClientService
      .getBACList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.bacList = res.data;
        },
      });
  }

  onRequestCreditChange(val: Event) {
    const event = val.target as HTMLInputElement;
    if (event.checked) {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isRequestCreditIncrease = true;
      }
    } else {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isRequestCreditIncrease = false;
      }
    }
  }

  onIsResale(val: Event) {
    const event = val.target as HTMLInputElement;
    if (event.checked) {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isResale = true;
      }
    } else {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isResale = false;
      }
    }
  }

  onTaxExemption(val: Event) {
    const event = val.target as HTMLInputElement;
    if (event.checked) {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isTaxExemption = true;
      }
    } else {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isTaxExemption = false;
      }
    }
  }

  onRequestCreditCheckSelection(val: Event) {
    const event = val.target as HTMLInputElement;

    if (event.checked) {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isRequestCreditCheck = true;
      }
    } else {
      if (this.clientBasicInformation) {
        this.clientBasicInformation.isRequestCreditCheck = false;
      }
    }
  }

  transformClientContactData() {
    this.ClientAddresses = [];
    if (this.clientType?.toLowerCase() === "client") {
      const Business = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Business
      );
      this.populateClientContactInformation(Business);
      const Invoice = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Invoice
      );
      this.populateClientContactInformation(Invoice);

      const Payment = this.clientContactInformation?.filter(
        x =>
          x.purposeD365?.toLowerCase() == "payable" ||
          x.purposeD365 == ClientPurposeType.Payment
      );
      this.populateClientContactInformation(Payment);
      const Delivery = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Delivery
      );
      this.populateClientContactInformation(Delivery);
      const Other = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Other
      );
      this.populateClientContactInformation(Other);
      const Buyer = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Buyer
      );
      this.populateClientContactInformation(Buyer);
    } else if (this.clientType?.toLowerCase() === "prospect") {
      const Business = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Business
      );
      this.populateClientContactInformation(Business);
      const Invoice = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Invoice
      );
      this.populateClientContactInformation(Invoice);

      const Payment = this.clientContactInformation?.filter(
        x =>
          x.purposeD365?.toLowerCase() == "payable" ||
          x.purposeD365 == ClientPurposeType.Payment
      );
      this.populateClientContactInformation(Payment);
      const Delivery = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Delivery
      );
      this.populateClientContactInformation(Delivery);
      const Other = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Other
      );
      this.populateClientContactInformation(Other);
      const Buyer = this.clientContactInformation?.filter(
        x => x.purposeD365 == ClientPurposeType.Buyer
      );
      this.populateClientContactInformation(Buyer);
    }
  }

  populateClientContactInformation(
    clientContacts: ClientContact[] | undefined
  ) {
    if (
      clientContacts != null &&
      clientContacts != undefined &&
      clientContacts.length > 0
    ) {
      const clientAddress: ClientAddressCustomize = {};
      clientAddress.purpose = clientContacts[0].purposeD365;
      clientAddress.isPrimary = clientContacts[0].isPrimaryD365;
      clientAddress.name = clientContacts[0].descriptionD365;
      clientAddress.cust = clientContacts[0].cust;
      clientAddress.title = clientContacts[0].title;

      // clientAddress.electronicAddressIdD365 =
      //   clientContacts[0].electronicAddressIdD365;

      if (
        clientContacts.find(x => x.typeD365 == EnumContactType.Phone) !=
        undefined
      ) {
        clientAddress.phone = clientContacts.find(
          x => x.typeD365 == EnumContactType.Phone
        )?.locatorD365;
        clientAddress.phoneLink =
          "tel:'" +
          clientContacts.find(x => x.typeD365 == EnumContactType.Phone)
            ?.locatorD365 +
          "'";
        if (this.clientType?.toLowerCase() === "client") {
          clientAddress.electronicAddressPhone = clientContacts.find(
            x => x.typeD365 == EnumContactType.Phone
          )?.electronicAddressIdD365;
        } else if (this.clientType?.toLowerCase() === "prospect") {
          clientAddress.electronicAddressPhone = clientContacts.find(
            x =>
              x.typeD365 == EnumContactType.Phone &&
              x.electronicAddressIdD365 !== ""
          )?.electronicAddressIdD365;
        }
      }
      if (
        clientContacts.find(x => x.typeD365 == EnumContactType.Email) !=
        undefined
      ) {
        clientAddress.email = clientContacts.find(
          x => x.typeD365 == EnumContactType.Email
        )?.locatorD365;
        clientAddress.emailLink =
          "mailto:'" +
          clientContacts.find(x => x.typeD365 == EnumContactType.Email)
            ?.locatorD365 +
          "'";
        clientAddress.electronicAddressEmail = clientContacts.find(
          x => x.typeD365 == EnumContactType.Email
        )?.electronicAddressIdD365;

        if (this.clientType?.toLowerCase() === "client") {
          clientAddress.electronicAddressEmail = clientContacts.find(
            x => x.typeD365 == EnumContactType.Email
          )?.electronicAddressIdD365;
        } else if (this.clientType?.toLowerCase() === "prospect") {
          clientAddress.electronicAddressEmail = clientContacts.find(
            x =>
              x.typeD365 == EnumContactType.Email &&
              x.electronicAddressIdD365 !== ""
          )?.electronicAddressIdD365;
        }
      }

      this.ClientAddresses.push(clientAddress);
    }
  }

  // CreateClientContractInformationData() {
  //   this._clientDetailsService
  //     .creatClientContract({})
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       // eslint-disable-next-line @typescript-eslint/no-empty-function
  //       next: () => {},
  //     });
  // }

  refreshingSummary() {
    this.ClientAddresses = [];
    this.clientAddressInformation = [];
    this.ngOnInit();
  }

  // getClientCreditCardInformationData() {
  //   this._clientDetailsService
  //     .getClientCreditCardInformation({})
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: res => {
  //         this.clientCreditCardInformation = res.data;
  //       },
  //     });
  // }

  // getCommissionSetupInformationData() {
  //   this._clientDetailsService
  //     .getCommissionSetupInformation({})
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: res => {
  //         this.clientCommissionSetupInformation = res?.data;
  //       },
  //     });
  // }

  // getMiscellaneousInformationData() {
  //   this._clientDetailsService
  //     .getMiscellaneousInformation({})
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: res => {
  //         this.clientMiscellaneousInformation = res.data;
  //       },
  //     });
  // }

  onContactTitleChange(clientContractObject: ClientContract) {
    this.showSmallLoader = true;
    this._clientDetailsService
      .UpdateContractClientData(clientContractObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  redirectToOpenInvoices(customerAccount: string, type: number) {
    this.openInvoiceDisplayModal = true;
    this.openInvoicetype = type;
    // this._router.navigate([
    //   `clients/active/open-invoices/${customerAccount}/${type}`
    // ]);
  }

  closeModal() {
    this.openInvoiceDisplayModal = false;
  }

  closeModalOnRedirection(event: string) {
    this.closeModalOnRedirectionEvent.emit(event);
    //this.refreshingSummary();
    this.openInvoiceDisplayModal = false;
  }

  closeClientModal() {
    this.closeModalOnRedirectionEvent.emit();
    this.closeEvent.emit();
    this.openInvoiceDisplayModal = false;
  }

  onClientContactDateChange(
    date: Date,
    clientContractObject: ClientContract,
    calendarRef?: Calendar
  ) {
    this.showSmallLoader = true;
    const formattedDate = this.datepipe.transform(date, "yyyy-MM-dd");
    if (clientContractObject) {
      if (calendarRef === this.refEffectiveTo) {
        clientContractObject.effectiveTo =
          this.parseToDate(formattedDate) ?? "";
      }
      if (calendarRef === this.refEffectiveFrom) {
        clientContractObject.effectiveFrom =
          this.parseToDate(formattedDate) ?? "";
      }
      this._clientDetailsService
        .UpdateContractClientData(clientContractObject)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onCustomerEffectFromDate(event: Date) {
    const date = new Date(event);
    this.effectFrom = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    const customerPOObject = {
      customerAccountD365: this.clientId?.toString(),
      customerPoEffectiveFrom: this.effectFrom,
      customerPoEffectiveTo: this.effectTo,
      customerPORequired: this.PoCheck,
    };
    this.updateCustomerPo(customerPOObject);
  }

  onCustomerEffectToDate(event: Date) {
    const date = new Date(event);
    this.effectTo = this.datepipe.transform(date, "MM/dd/yyyy") ?? "";
    const customerPOObject = {
      customerAccountD365: this.clientId?.toString(),
      customerPoEffectiveFrom: this.effectFrom,
      customerPoEffectiveTo: this.effectTo,
      customerPORequired: this.PoCheck,
    };
    this.updateCustomerPo(customerPOObject);
  }

  updateCustomerPoField(event: Event) {
    const val = event.target as HTMLInputElement;
    this.PoCheck = val.checked;
    // const customerPOObject = {
    //   customerAccountD365: this.clientId?.toString(),
    //   customerPoEffectiveFrom: this.effectFrom,
    //   customerPoEffectiveTo: this.effectTo,
    //   customerPORequired: this.PoCheck
    // };
    // this.updateCustomerPo(customerPOObject);

    this.updateClientSummaryData();
  }

  updateCustomerPo(customerPOObject: UpdateCustomerPODto) {
    this.showSmallLoader = true;
    this._clientDetailsService
      .UpdateCustomerPOData(customerPOObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._toastr.success("Success", "Client update client");
          this.showSmallLoader = false;
        },
        error: res => {
          this._toastr.error("Error", res.message ?? "Error updating client");
          this.showSmallLoader = false;
        },
      });
  }

  async getClientContactTitleOneFile(
    event: Event,
    clientContractObject: ClientContract
  ) {
    const fileInput = event.target as HTMLInputElement;
    if (!fileInput.files || fileInput.files.length === 0) {
      return;
    }
    const fileObj = fileInput.files[0];
    this.showSmallLoader = true;
    const fileSize = Math.round(fileObj.size / 1024);
    if (fileSize <= 1024) {
      if (this.clientContractInformation != undefined) {
        if (fileInput.id == this.clientContractFileIdOne) {
          this.clientContractInformation[0].fileName = fileObj.name;
        } else if (fileInput.id == this.clientContractFileIdTwo) {
          this.clientContractInformation[1].fileName = fileObj.name;
        }
      }
      const fileExtension = fileObj?.name
        ? "." + fileObj.name.split(".").pop()?.toLowerCase()
        : "";
      await getBase64(fileObj).then(base64Url => {
        if (fileInput.id == this.clientContractFileIdOne) {
          this.createFileUploadDto(
            base64Url as string,
            ClientContactType.ContactFileOne,
            fileExtension,
            fileSize,
            fileObj.type
          );
        } else if (fileInput.id == this.clientContractFileIdTwo) {
          this.createFileUploadDto(
            base64Url as string,
            ClientContactType.ContactFileTwo,
            fileExtension,
            fileSize,
            fileObj.type
          );
        }
        this.uploadFile(this.fileObject, clientContractObject);
      });
      this.contactoneFileSize = false;
    } else {
      this.contactoneFileSize = true;
    }
  }
  uploadFile(fileObj: FileUploadDto[], clientContractObject: ClientContract) {
    if (fileObj.length != 2) {
      this._clientDetailsService
        .getContacttitleAttachmentUrl(fileObj)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.fileUrl = res.data;
            clientContractObject.uri = this.fileUrl;
            this.showSmallLoader = false;
            this.onContactTitleChange(clientContractObject);
          },
        });
    } else {
      this._clientDetailsService
        .getContacttitleSecondAttachmentUrl(fileObj)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.fileUrl = res.data;
            clientContractObject.uri = this.fileUrl;
            this.showSmallLoader = false;
            this.onContactTitleChange(clientContractObject);
          },
        });
    }
  }

  createFileUploadDto(
    base64Url: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = base64Url.split(",")[1];
    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  //formatter = (state: any) => state.nameAliasD365;
  formatter = (x: { nameAliasD365: string }) => x.nameAliasD365;
  // searchParentCompanyName: OperatorFunction<string, readonly unknown[]> = (
  //   text$: Observable<string>
  // ) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     filter(term => term.length >= 3),
  //     map(term =>
  //       this.parentCompanyNameList.filter((state: Client) =>
  //         new RegExp(term, "mi").test(state.nameAliasD365)
  //       )
  //     )
  //   );
  filteredParentCompanies: Client[] = [];

  filterParentCompanies(event: { query: string }) {
    const query = event.query.toLowerCase();
    this.filteredParentCompanies = this.parentCompanyNameList.filter(
      (company: Client) => company.nameAliasD365.toLowerCase().includes(query)
    );
  }

  // searchParentCompany(event: any) {
  //   this.parentCompanySuggestions = this.filterCompanies(event.query);
  // }

  // private filterCompanies(query: string): any[] {
  //   return this.parentCompanyNameList.filter(company =>
  //     company.nameAliasD365.toLowerCase().includes(query.toLowerCase())
  //   );
  // }

  attachmentFileObject(attachmentObject: ClientAttachment[]) {
    if (attachmentObject.length > 0) {
      if (attachmentObject[0].descriptionD365 === "resale") {
        this.documentType = "resale";
      } else if (attachmentObject[0].descriptionD365 === "taxexemption") {
        this.documentType = "taxexemption";
      }
      if (this.clientId) {
        attachmentObject[0].customerAccountD365 = this.clientId;
      }
      const createClientDocumentDto = {
        clientAttachment: attachmentObject[0],
        clientDocumentType: this.documentType,
      };
      this._clientDetailsService
        .addClientSummaryAttachment(createClientDocumentDto)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: () => {
            this.showSmallLoader = false;

            this._toastr.success("Success", "Client update client");
          },
          error: () => {
            this.showSmallLoader = false;

            this._toastr.error("Error", "Error updating client");
          },
        });
    }
  }

  updateClientSummaryData(flag: string = "") {
    const clientSummaryForm = this.clientSummaryForm.getRawValue();
    const miscellaneousDataForm =
      this.miscellaneousDataForm.getRawValue() as Client;

    if (this.clientId) {
      clientSummaryForm.customerAccountD365 = this.clientId;
    }

    if (miscellaneousDataForm.priority) {
      const priority = miscellaneousDataForm.priority.split("-")[1];
      miscellaneousDataForm.priority = priority.trim();
    } else {
      miscellaneousDataForm.priority = "10";
    }

    if (!clientSummaryForm.requestCreditIncreaseAmount) {
      clientSummaryForm.requestCreditIncreaseAmount = 0;
    }
    if (
      typeof clientSummaryForm.rsmJNIParentCompanyNameD365 === "object" &&
      clientSummaryForm.rsmJNIParentCompanyNameD365 !== null &&
      typeof clientSummaryForm.rsmJNIParentCompanyNameD365 === "object" &&
      clientSummaryForm.rsmJNIParentCompanyNameD365 !== null &&
      clientSummaryForm.rsmJNIParentCompanyNameD365.hasOwnProperty(
        "nameAliasD365"
      )
    ) {
      clientSummaryForm.rsmJNIParentCompanyNameD365 =
        clientSummaryForm.rsmJNIParentCompanyNameD365.nameAliasD365;
    }

    if (clientSummaryForm) {
      if (
        clientSummaryForm.billingAttentionD365 &&
        (clientSummaryForm.billingAttentionD365 as string).length > 30
      ) {
        this._toastr.error("Attention must be less than 30 characters.");
        return;
      }

      if (
        clientSummaryForm.billingLocationD365 &&
        (clientSummaryForm.billingLocationD365 as string).length > 30
      ) {
        this._toastr.error("Location must be less than 30 characters.");
        return;
      }

      if (flag === "sourceRequired" && !clientSummaryForm.source) {
        this._toastr.error("Client Origin is required.");
        return;
      }

      if (flag === "companyUrlRequried" && !clientSummaryForm.companyUrl) {
        this._toastr.error("Company URL is required.");
        return;
      }
    }

    this._loaderService.setLoaderState(true);

    const updateClientSummaryForm = {
      ...clientSummaryForm,
      ...miscellaneousDataForm,
    };

    if (updateClientSummaryForm) {
      updateClientSummaryForm.isPONumberRequired = this.PoCheck;
    }

    this._clientDetailsService
      .UpdateClientSummaryData({ client: updateClientSummaryForm })
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error("Error", res.message ?? "Error updating client");
          } else {
            this._toastr.success("Success", "Client update successfully");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message ?? "Error updating client");
        },
      });
  }

  onToggle() {
    this.isCollapsed = !this.isCollapsed;
    this.isCollapseOne = !this.isCollapseOne;
    this.isCollapseTwo = !this.isCollapseTwo;
    this.isCollapseThree = !this.isCollapseThree;
    this.isCollapseFour = !this.isCollapseFour;
    this.isCollapseFive = !this.isCollapseFive;
    this.isCollapseSix = !this.isCollapseSix;
    this.isCollapseSeven = !this.isCollapseSeven;
  }

  getAvailableCredit() {
    if (this.clientId) {
      this._clientDetailsService
        .getAvailableCredit(this.clientId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.data) {
              this.customerBalance = res?.data?.availableCredit;
              this.lastOrderDate = res?.data?.lastOrderDate;
              this.invoiceDate = res?.data?.invoiceDate;
              this.openReceivables = res?.data?.openReceivables;
            } else {
              this.customerBalance = 0;
              this.lastOrderDate = "";
              this.invoiceDate = "";
            }
          },
        });
    }
  }

  getOpenOrder() {
    if (this.clientId) {
      this._clientDetailsService
        .getOpenOrder(this.clientId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.openOrders = res.data;
            } else {
              this.openOrders = 0;
            }
          },
        });
    }
  }

  getFYTDSales() {
    if (this.clientId) {
      this._clientDetailsService
        .getFYTDSales(this.clientId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.FYTDSales = res.data;
            } else {
              this.FYTDSales = 0;
            }
          },
        });
    }
  }

  extractRoles(role: string | undefined) {
    return role ? role.split(";").join(" ") : "";
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  addScollHiddenClass() {
    if (this.clientModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  onEditContactUpdated(obj: boolean) {
    if (obj) this.ngOnInit();
  }

  onEditAddressUpdated(obj: boolean) {
    if (obj) this.ngOnInit();
  }

  redirectToOpenCustomerInvoices(clientId: string) {
    this._router.navigate([
      `/reports/open-customer-invoices-report/${clientId}`,
    ]);
  }

  redirectToArAgingDetailsReport(customerAccount: string, type: string) {
    const url = `/reports/ar-aging-detail-report/${customerAccount}/${type}`;
    this._router.navigate([url]);
  }

  redirectClientArchive() {
    this.openClientArchiveModal = true;
  }

  closeArchiveModal() {
    this.openClientArchiveModal = false;
  }

  fileDownload(url: string | undefined) {
    if (url !== undefined) {
      this._sharedService.getFileAsBlob(url).subscribe({
        next: res => {
          const blob = new Blob([res], { type: res.type });
          const blobUrl = URL.createObjectURL(blob);
          window.open(blobUrl);
        },
      });
    }
  }

  formatCreditCheckDate(date: string | null | undefined): string {
    if (!date || date.startsWith("1900-01-01")) return "";
    return this.datepipe.transform(date, "MM-dd-yyyy") ?? "";
  }

  parseToDate(value: string | Date | null): Date | null {
    if (!value) return null;

    if (typeof value === "string") {
      const datePart = value.split("T")[0].split(" ")[0];
      const [year, month, day] = datePart.split("-").map(Number);

      if (
        !isNaN(year) &&
        !isNaN(month) &&
        !isNaN(day) &&
        year > 0 &&
        month > 0 &&
        day > 0
      ) {
        return new Date(year, month - 1, day);
      }
      return new Date(value);
    }

    if (value instanceof Date) {
      return new Date(value.getFullYear(), value.getMonth(), value.getDate());
    }

    return null;
  }
}
